import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";
import Layers from "slotworks/graphics/layers/layers";
import RevolverWinTransitions from "./revolver-win-transitions";
import Timer from "slotworks/utils/timer";
import { parallel, sequence } from "slotworks/utils/race-utils";
import { BounceZoomIn, FadeOut, FadeIn, ZoomOut, EndlessHover } from "slotworks/graphics/animation/base-animations";
import Point from "slotworks/utils/geom/point";
import gameState from "slotworks/model/game-state";
import Components from "slotworks/components/components";
import soundManager from "slotworks/sound/sound-manager";

export default class BigWinTransitions extends RevolverWinTransitions {
    public EXPLOSION_TIME: number = 200;
    public TEXT_ZOOM = 1.1;
    public TEXT_ZOOM_TWEEN = 0.95;    

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.resetBasic();

            const tiers = this.getSelectedTiers();
            let wintype = [
                'big',
                'mega',
                'supermega',
                'epic'
            ];
            soundManager.customEvent(`${wintype[tiers.length - 1]}_win`);
            const sequence = Layers.CelebrationContent.getSpineSequence(SPINE_WINS[tiers.length - 1]);

            RevolverWinTransitions.winValue.visible = false;
            this.inResolve = resolve;

            FadeIn(RevolverWinTransitions.background, this.BOUNCE_TIME).execute();      
            sequence.play();
            RevolverWinTransitions.winValue.visible = true;
            BounceZoomIn(RevolverWinTransitions.winValue, this.BOUNCE_TIME).execute();
            this.resolveIn()
        });
    }

    public skipIn() {
        soundManager.customEvent("big_win");
        RevolverWinTransitions.winValue.visible = true;        
        this.setTextSize(this.TEXT_ZOOM);
        this.resolveIn();
    }

    public out(): Contract<void> {    
        TweenJS.removeAll(RevolverWinTransitions.winValue.scale);    
        const totalWin = gameState.getCurrentGame().totalCreditsWon;
        Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);  
        soundManager.customEvent("plaque_transition");
        return sequence([
            () => ZoomOut(RevolverWinTransitions.winValue, 100),
            () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME),
            () => Contract.getTimeoutContract(750)            
        ]);
    }

    public destroy() {
        this.clearTimers();
        
        super.destroy();
    }

}

const SPINE_WINS = [
    "a_sequence_1_big_win",
    "a_sequence_2_mega_win",
    "a_sequence_3_super_win",
    "a_sequence_4_epic_win"
]


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/big-win-transitions.ts